import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import cn from '@/lib/clsxm';
import { currency } from '@/lib/helper';
import PaymentInputShape from '@/components/payment-with-id/paymentInputShape';
import Button from '@/components/@base/button';
import samanBankLogo from '@/assets/logos/saman-bank-logo.svg';
import React from 'react';
import useHomeStore from '@/store/home';

const AddWalletWithId = ({showPreInvoice, isLoading, className}:{showPreInvoice: () => void, isLoading: boolean, className?:string}) => {
  const { remainInvoice, isActiveRequest } = useHomeStore();
  return (
    <Container className={cn(className)}>
      <Container center className='flex-col w-full rounded-xl bg-grayLight-50 dark:bg-grayDark-750 p-[2px] pt-6 '>
        <Text className='text-black dark:text-white leading-7 text-md'>
          {localization.invoiceBalance}
        </Text>
        <Text className={cn('text-[24px] text-black dark:text-white')} semiBold>
          {currency(remainInvoice)}
          <span className='text-sm font-medium'>{localization.rial}</span>
        </Text>
        <Container className="bg-white dark:bg-grayLight-990 rounded-xl px-4 py-5 w-full mt-4">
          <PaymentInputShape/>
          <Button
            className={cn(
              'flex text-md bg-blue dark:bg-blue hover:bg-blue/90 h-[52px] w-full rounded-full !text-white mt-3'
            )}
            onClick={showPreInvoice}
            disabled={isLoading || isActiveRequest}
            isLoading={isLoading}
          >
            <img
              src={samanBankLogo}
              width={32}
              height={32}
              alt='saman bank logo'
            />
            {localization.paymentWithIPG}
          </Button>
        </Container>
      </Container>
    </Container>
  );
}
export default AddWalletWithId